/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Currency,
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    OrderObjectType,
    OrderObjectTypeFromJSON,
    OrderObjectTypeFromJSONTyped,
    OrderObjectTypeToJSON,
} from './OrderObjectType';
import {
    OrderStatus,
    OrderStatusFromJSON,
    OrderStatusFromJSONTyped,
    OrderStatusToJSON,
} from './OrderStatus';
import {
    PaymentMethod,
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
} from './PaymentMethod';

/**
 * 
 * @export
 * @interface OrderSummary
 */
export interface OrderSummary {
    /**
     * 
     * @type {string}
     * @memberof OrderSummary
     */
    id: string;
    /**
     * 
     * @type {OrderObjectType}
     * @memberof OrderSummary
     */
    object: OrderObjectType;
    /**
     * 
     * @type {Currency}
     * @memberof OrderSummary
     */
    amount_returned: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof OrderSummary
     */
    amount_cost: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof OrderSummary
     */
    amount_fee: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof OrderSummary
     */
    amount_total: Currency;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof OrderSummary
     */
    checkout_methods: Array<PaymentMethod>;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof OrderSummary
     */
    currency: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof OrderSummary
     */
    customer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSummary
     */
    program_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSummary
     */
    receipt_number: string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderSummary
     */
    status: OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof OrderSummary
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderSummary
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderSummary
     */
    updated: Date;
}

export function OrderSummaryFromJSON(json: any): OrderSummary {
    return OrderSummaryFromJSONTyped(json, false);
}

export function OrderSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': OrderObjectTypeFromJSON(json['object']),
        'amount_returned': CurrencyFromJSON(json['amount_returned']),
        'amount_cost': CurrencyFromJSON(json['amount_cost']),
        'amount_fee': CurrencyFromJSON(json['amount_fee']),
        'amount_total': CurrencyFromJSON(json['amount_total']),
        'checkout_methods': ((json['checkout_methods'] as Array<any>).map(PaymentMethodFromJSON)),
        'currency': CurrencyCodeFromJSON(json['currency']),
        'customer_name': !exists(json, 'customer_name') ? undefined : json['customer_name'],
        'program_name': json['program_name'],
        'receipt_number': json['receipt_number'],
        'status': OrderStatusFromJSON(json['status']),
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function OrderSummaryToJSON(value?: OrderSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': OrderObjectTypeToJSON(value.object),
        'amount_returned': CurrencyToJSON(value.amount_returned),
        'amount_cost': CurrencyToJSON(value.amount_cost),
        'amount_fee': CurrencyToJSON(value.amount_fee),
        'amount_total': CurrencyToJSON(value.amount_total),
        'checkout_methods': ((value.checkout_methods as Array<any>).map(PaymentMethodToJSON)),
        'currency': CurrencyCodeToJSON(value.currency),
        'customer_name': value.customer_name,
        'program_name': value.program_name,
        'receipt_number': value.receipt_number,
        'status': OrderStatusToJSON(value.status),
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
    };
}

